<template>
  <div id="app" class="gbwaps-app">
    <SiteHeader />
    <router-view />
    <StickyDownload />
    <SiteFooter />
  </div>
</template>

<script>
import SiteHeader from '@/components/gbwaps/SiteHeader.vue';
import SiteFooter from '@/components/gbwaps/SiteFooter.vue';
import StickyDownload from '@/components/gbwaps/StickyDownload.vue';

export default {
  name: 'App',
  components: {
    SiteHeader,
    SiteFooter,
    StickyDownload,
  },
  mounted() {
    this.$logEvent('show_gbwaps');
  },
};
</script>
